export const WAND_PRIMARY_COLOR = "#0f7dff";
